// @ts-nocheck
import React from 'react';
import { useTier } from '../hooks/useTier';
import { UpgradePrompt } from '../components/UpgradePrompt';
import { useQuery } from 'wasp/client/operations';
// TODO: Implement getAnalyticsData operation
// Placeholder stub for compilation
const getAnalyticsData = () => ({});
import { Card, CardContent, CardHeader, CardTitle } from '../v32/components/ui/card';
import { Button } from '../v32/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../v32/components/ui/select';
import { AppFrame } from '../v32/components/AppFrame';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface AnalyticsData {
  period: 'week' | 'month' | 'all';
  totalPlans: number;
  totalCost: number;
  avgCostPerPlan: number;
  avgCaloriesPerPlan: number;
  recipeCounts: Record<string, number>;
}

export function AnalyticsDashboard() {
  const { tier, canAccess } = useTier();

  if (!canAccess('core_plus')) {
    return <UpgradePrompt requiredTier="core_plus" featureName="Advanced Analytics" />;
  }

  const [period, setPeriod] = React.useState<'week' | 'month' | 'all'>('month');

  const { data: analyticsData } = useQuery(getAnalyticsData, { period });

  const chartData = Object.entries(analyticsData?.recipeCounts || {}).map(([type, count]) => ({
    name: type,
    count,
  }));

  return (
    <AppFrame>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">Analytics Dashboard</h1>
          <Select value={period} onValueChange={(value) => setPeriod(value as any)}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Select period" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="week">Last Week</SelectItem>
              <SelectItem value="month">Last Month</SelectItem>
              <SelectItem value="all">All Time</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Total Plans</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-3xl font-bold">{analyticsData?.totalPlans || 0}</p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Total Cost</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-3xl font-bold">${analyticsData?.totalCost?.toFixed(2) || '0.00'}</p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Avg Cost per Plan</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-3xl font-bold">${analyticsData?.avgCostPerPlan?.toFixed(2) || '0.00'}</p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Avg Calories per Plan</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-3xl font-bold">{Math.round(analyticsData?.avgCaloriesPerPlan || 0)} cal</p>
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Meal Types Distribution</CardTitle>
          </CardHeader>
          <CardContent>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="count" fill="#FF6B6B" />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </div>
    </AppFrame>
  );
}
